import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const AccountReactivationIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => ACCOUNT_REACTIVATION_TITLE(strictLocalize),
    getDescription: () => [ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize)],
  };
};

const ACCOUNT_REACTIVATION_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Account reactivation",
    description: {
      text: "Title for the answer of reactivating account.",
    },
  });

const ACCOUNT_REACTIVATION_DESCRIPTION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "If you previously deactivated your account, you can submit a reactivation request using the contact us option below. Note: any account verification related requests should go through My Account > Onboarding > Account Verification",
  });
